import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFigma} from "@fortawesome/free-brands-svg-icons";

const Button = ({link}) => {
    return <button className="btn btn-primary">
        <a href={link} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faFigma} />Design de cette maquette
        </a>
        </button>;
}

export default Button;
